import React from "react";
import { X } from "lucide-react";
import LocationPicker from "@/components/LocationPicker";

// Fallback when device location is denied/unavailable: the user picks a place explicitly (sent as source=manual).
export function ManualPinSheet({ reason, onPick, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/40 grid place-items-end md:place-items-center p-4" style={{ zIndex: "var(--z-modal)" }} onClick={onClose} data-testid="manual-pin-sheet">
      <div onClick={(e) => e.stopPropagation()} className="w-full max-w-md rounded-2xl bg-white p-5 shadow-2xl max-h-[90dvh] overflow-y-auto">
        <div className="flex items-center justify-between mb-2">
          <div className="font-bold text-lg text-stone-900">Pick a place to share</div>
          <button onClick={onClose} className="p-1 text-stone-500" aria-label="Close" data-testid="manual-pin-close"><X size={18} /></button>
        </div>
        {reason && <p className="text-sm text-amber-800 bg-amber-50 rounded-lg p-2 mb-3" data-testid="manual-pin-reason">{reason}</p>}
        <p className="text-xs text-stone-500 mb-3">Search or tap the map. This is sent as a chosen place, not your live position.</p>
        <LocationPicker value={null} onChange={onPick} />
      </div>
    </div>
  );
}
